export const camelCaseToWords = str => {
  if (!str) return '';
  const result = str.replace(/([A-Z])/g, ' $1').toLowerCase();
  return result.charAt(0).toUpperCase() + result.slice(1);
};
